export default "__VITE_ASSET__lHOgEZd0__"